const validaMenor = (data) => {
    let birthDay = new Date(data.substr(6,4), data.substr(3, 2), data.substr(0,2))
    let diff = Date.now - birthDay.getTime()
    let ageDate = new Date(diff)

    ageDate = Math.abs(ageDate.getUTCFullYear() - 1970);
    
    if (ageDate > 12) {
        return false
    } else {
        return true
    }
}

export default validaMenor;